import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { IconSize, RmaIconComponent } from '@rma/generic/ui/icon';
import { SyndicationChannel, syndicationChannels, SyndicationChannelSettings } from '../domain/syndication-channels.model';
import { ChannelIconPipe } from '../util-channel-icon/channel-icon.pipe';
import { ChannelNamePipe } from '../util-channel-name/channel-name.pipe';

@Component({
  selector: 'rma-syndication-channel-list',
  imports: [RmaIconComponent, ChannelIconPipe, ChannelNamePipe, MatTooltipModule, TranslocoModule],
  templateUrl: './syndication-channels.component.html',
  host: {
    class: 'align-start flex flex-wrap gap-2',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [provideTranslocoScope('syndicationChannels')],
})
export class SyndicationChannelListComponent {
  public readonly channels = input<SyndicationChannel[] | SyndicationChannelSettings[]>([]);
  public readonly iconSize = input<IconSize>('small');

  protected readonly channelSettings = computed(() => {
    const channels = this.channels();

    if (!channels?.length) {
      return [];
    }

    return channels
      .map((c: SyndicationChannel | SyndicationChannelSettings) => (typeof c === 'string' ? { name: c } : c))
      .filter((c) => syndicationChannels.includes(c.name));
  });
}
